import { Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { JournalPost } from '../../interfaces/journal-post';
import { WordpressService } from '../../services/wordpress.service';

@Component({
  selector: 'app-journal-post-related',
  templateUrl: './journal-post-related.component.html',
  styleUrls: ['./journal-post-related.component.scss']
})
export class JournalPostRelatedComponent implements OnInit, OnChanges, OnDestroy {
  @Input() relatedPosts: {post: JournalPost}[];
  @Input() currentPostId: number;
  postSubscribe;
  allPostsSubscribe;
  posts: JournalPost[] = [];

  constructor(
    private wp: WordpressService
  ) { }

  getRelatedPosts() {
    if (this.relatedPosts && this.relatedPosts.length) {
      // Get related posts acf content
      const _relatedPosts = this.relatedPosts.map(item => item.post);
      _relatedPosts.forEach(post => {
        this.postSubscribe = this.wp.getJournalPost(post.post_name).subscribe(res => {
          if (res && res.length) {
            this.posts.push(res[0]);
          }
        });
      });
    } else {
      // Get two latest posts
      this.allPostsSubscribe = this.wp.getJournalPosts(1).subscribe(res => {
        if (res && res.body && res.body.length) {
          // Filter out current post
          const _filteredPosts = res.body.filter(item => item.id !== this.currentPostId);
          this.posts = _filteredPosts && _filteredPosts.length ? _filteredPosts.slice(0, 2) : null;
        }
      });
    }
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.posts = [];
    this.getRelatedPosts();
  }

  ngOnDestroy() {
    if (this.allPostsSubscribe) {
      this.allPostsSubscribe.unsubscribe();
    }

    if (this.postSubscribe) {
      this.postSubscribe.unsubscribe();
    }
  }
}
